import { AccountAuditLogs } from '@/features/audit-logs/account-audit-logs';

export default function AuditLogsPage() {
  return <AccountAuditLogs />;
}
